// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Oo526","right":"styles_right__2iw5R"};